import {
  EnvironmentProviders,
  inject,
  isDevMode,
  makeEnvironmentProviders,
  provideAppInitializer,
} from '@angular/core';

import { provideTransloco } from '@jsverse/transloco';
import { provideTranslocoMessageformat } from '@jsverse/transloco-messageformat';

import { FuryTranslocoLoader } from './fury-transloco.loader';
import { buildTranslocoConfig } from './i18n.config';
import { LocaleService } from './locale.service';

/**
 * Registers localization: Transloco with the Fury catalog loader and ICU messages, plus an app
 * initializer that holds bootstrap until the global catalogs of the resolved language are loaded,
 * so the shell never paints an untranslated key.
 */
export function provideFuryI18n(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideTransloco({ config: buildTranslocoConfig(isDevMode()), loader: FuryTranslocoLoader }),
    provideTranslocoMessageformat(),
    provideAppInitializer(() => inject(LocaleService).init()),
  ]);
}
